import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  

  {
    path: '/',
    name: 'Landing',
    component: () => import('../views/LandingView.vue')
  },
  {
    path: '/endnote',
    name: 'Endnote',
    component: () => import('../views/EndnoteView.vue')
  },
  {
    path: '/universidad',
    name: 'Universidad',
    component: () => import('../views/UniversidadView.vue')
  },
  {
    path: '/formacion-gratuita/desempleados',
    name: 'Desempleados',
    component: () => import('../views/DesempleadosView.vue')
  },
  {
    path: '/formacion-gratuita/autonomos',
    name: 'Autonomos',
    component: () => import('../views/AutonomosView.vue')
  },
  {
    path: '/oposiciones',
    name: 'Oposiciones',
    component: () => import('../views/OposicionesView.vue')
  },
  {
    path: '/aulas',
    name: 'Aulas',
    component: () => import('../views/AulasView.vue')
  },
  {
    path: '/formacion-profesional/daw',
    name: 'Daw',
    component: () => import('../views/DawView.vue')
  },
  {
    path: '/formacion-profesional/administracion-finanzas',
    name: 'Finanzas',
    component: () => import('../views/FinanzasView.vue')
  },
  {
    path: '/formacion-empresas/formacion-bonificada',
    name: 'Bonificada',
    component: () => import('../views/FormacionboniView.vue')
  },
  {
    path: '/formacion-empresas/practicas-empresas',
    name: 'PracticasEmpresas',
    component: () => import('../views/PracticasEmpresasView.vue')
  },
  {
    path: '/ingles/certificaciones',
    name: 'Certificaciones',
    component: () => import('../views/InglesView.vue')
  },
  {
    path: '/ingles/20go',
    name: '20Go',
    component: () => import('../views/20GoView.vue')
  },
  {
    path: '/formacion-empresas/team-building',
    name: 'TeamBuilding',
    component: () => import('../views/TeamBuildingView.vue')
  },
  {
    path: '/aula-virtual',
    name: 'AulaVirtual',
    component: () => import('../views/AulaVirtualView.vue')
  },
  {
    path: '/valingual',
    name: 'Valingual',
    component: () => import('../views/ValingualView.vue')
  },
  {
    path: '/aviso-legal',
    name: 'AvisoLegal',
    component: () => import('../views/AvisoLegalView.vue'),
    
  },
  {
    path: '/politica-privacidad',
    name: 'PoliticaPrivacidad',
    component: () => import('../views/PoliticaPrivacidadView.vue')
  },
  {
    path: '/politica-cookies',
    name: 'PoliticaCookies',
    component: () => import('../views/PoliticaCookiesView.vue')
  },
  {
    path: '/admincursos',
    name: 'AdminCursos',
    component: () => import('../views/AdminCursosView.vue'),
    beforeEnter: (to, from, next) => {
      // La autenticación se maneja dentro del componente
      next()
    }
  }
  
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Si hay una posición guardada (al usar atrás/adelante), la usa
    if (savedPosition) {
      return savedPosition;
    } else {
      // Si es una navegación nueva, sube al inicio (x: 0, y: 0)
      return { top: 0 };
    }
  },
})

export default router
